<template lang="pug">
.cm-body(:class="{'without-course-config': !activeSingleCourse || !activeSingleCourse.ID, 'curssusen-body': isCurssusenPage}") 
  .cm-body__wrapper
    filters(
      @filterChanged="loadList"
    )
    grouped-table(
      v-if="isCursssusenPage"
      v-model="activeItems"
      :headers="headers"
      :loading="loading"
      :groupedList="groupedList"
      itemKey="ID"
      class="app-table cm-body__table v-data-table theme--light"
      :class="{'table-curssusen': isCurssusenPage}"
    )
      template(v-slot:top)
        .pr-4.pt-2.pb-2.d-flex.cm-top
          tabs(
            :key="`${$route.query.city}-${$route.query.course_id}`"
            :candidatesCount="candidatesCount"
            @changed="onTabsChange"
          )
        div(:class="{'select-bg-color': activeItems.length && !isMultipleMode, 'multiple-select-bg-color': activeItems.length && isMultipleMode }" ).cm-actions.px-4.pt-2.pb-1.d-flex
          div(v-if="activeItems.length").app-table__selected-items-title.mr-2 {{ activeItems.length}} items selected
          select-all(
            v-if="showSelectAll"
            @change="selectAllClick"
            :activeItemsCount="activeItems.length"
            :itemsToSelectCount="pagination.count"
          ).mr-2
          v-spacer(v-if="activeItems.length")
          accept-test(:activeItems="activeItems" v-if="!isCurssusenPage && !isReservedPage").mr-2
          acceptBulk(:activeItems="activeItems" v-if="!isCurssusenPage && !isReservedPage").mr-2
          markAsProcessedBulk(
            :activeItems="activeItems"
            @clearSelection="clearSelection"
            ).mr-3
          addRequests(
            :disabled="!activeItems.length"
            :activeItems="activeItems"
            :defaultCourse="activeSingleCourse"
            v-if="!disabledAddExam"
          ).mr-2
          
          removeRequests(
            :disabled="!activeItems.length"
            :activeItems="activeItems"
            :defaultCourse="activeSingleCourse"
            v-if="isReserveQueuePage || isExchangeQueuePage"
            ).mr-2
          removeFromAcceptance(
            :disabled="!activeItems.length"
            :activeItems="activeItems"
            v-if="!isReservedPage"
          ).mr-2
          try-to-reserve(:activeItems="activeItems" :disabled="!activeItems.length" v-if="isReservedPage").mr-2

          handleFailedCandidatesProvider(v-slot="handleFailed")
            span
              v-dialog(:value="handleFailed.showing" @input="handleFailed.toggle" scrollable)
                handleFailedBody(
                  :list="handleFailed.failedCandidates"
                  :error="handleFailed.error"
                  :totalSendCount="handleFailed.totalSendCount"
                  @input="handleFailed.toggle"
                )
              span.d-flex
                mijn-bulk(
                  v-if="!isCurssusenPage && !isReservedPage"
                  :disabled="!activeItems.length"
                  :activeItems="activeItems"
                  @send="handleFailed.check($event, activeItems.length)"
                ).mr-2
                bulk-assign-labels(:disabled="!activeItems.length" :activeItems="activeItems").mr-2
                bulk-assign-labels(btnText="Unassign labels" mode="remove" :disabled="!activeItems.length" :activeItems="activeItems").mr-2
                addRequests(
                  exchange
                  :title="'Exchange exam'"
                  :disabled="!activeItems.length"
                  :activeItems="activeItems"
                  :defaultCourse="activeSingleCourse"
                  @send="handleFailed.check($event, activeItems.length)"
                  v-if="isReservedPage || isExchangeQueuePage"
                ).mr-2
                exchange(
                  :disabled="!activeItems.length" 
                  :activeItems="activeItems" 
                  :title="isReserveQueuePage ? 'Suggest exam': 'Suggest exchange'"
                  @send="handleFailed.check($event, activeItems.length)"
                  :isExchange="isReserveQueuePage ? false : true"
                  v-if="isReservedPage || isExchangeQueuePage || isReserveQueuePage"
                ).mr-2
                quickReserve(
                  :activeItems="activeItems" 
                  :disabled="!activeItems.length" 
                  @create="quickReserveHandler(handleFailed.check, $event)"
                  v-if="!disabledAddExam"
                ).mr-2
                quickReserve(
                  :activeItems="activeItems" 
                  :disabled="!activeItems.length" 
                  @create="quickReserveHandler(handleFailed.check, $event)"
                  title="Quick Exchange"
                  isExchange=true
                  v-if="isReservedPage || isExchangeQueuePage"
                )
          sync(
            :activeItems="activeItems"
            :disabled="!activeItems.length"
          ).mr-2
          changeCourseBulk(
            v-if="isReservedPage"
            :activeItems="activeItems" 
            :disabled="!activeItems.length"
            @send="onChangeCourseBulk"
          ).mr-2
          courseConfigurationBulk(
            :activeItems="activeItems"
            multiple
          )
            template(v-slot:activator="{on}")
              v-btn(small color='primary' 
                v-on="on"
                :disabled="!activeItems.length"
                outlined
              ).mr-2 course configuration

          copy(:activeItems="activeItems" :disabled="!activeItems.length" :list="list" multiple)
          candidate-color.mr-2(:activeItems="activeItems" :disabled="!activeItems.length")

      template(v-slot:header="headerRow")

        header-row(:headerRow="headerRow")
      template(v-slot:item="{item, select, isSelected, index, expand, isExpanded}")
        course-row(
          :item="item",
          :index="index"
          :key="item.ID"
          :isSelected="isSelected"
          :select="select"
          :expand="expand"
          :isExpanded="isExpanded"
          :activeItems="activeItems"
          :primaryPagination="primaryPagination"
          :labels="labels"
          @click:payments="paymentsOpen"
          @onGoToEdit="goToEdit"
          @selectedWithShiftkey="extendedGroupSelection"
          @onWillComeUpdate="$emit('needToUpdate:courses')"
        )

      template( v-slot:expanded-item="{ headers, item }")
        td(:colspan="headers.length").pl-0.pr-0.app-table__expand
          candidate-item(
            :ID="item.ID"
            @close="hideExpandBy"
            ref="expand"
            :key='item.ID'
            @saved="updateTableDataBy(item, $event)"
          ).pb-12
    v-data-table(
      v-if="!isCursssusenPage"
      :headers="headers"
      item-key="ID"
      hide-default-footer
      hide-default-header
      :loading="loading"
      class="app-table cm-body__table"
      :items="list"
      :server-items-length="list.length"
      :mobile-breakpoint='NaN'
      multi-sort=false
      :sort-by.sync="sortModel.by"
      :sort-desc.sync="sortModel.desc"
      :expanded.sync="expanded"
      single-expand=true
      @update:sort-desc="updateSorting"
      show-select
      v-model="activeItems"
      :class="{'table-curssusen': isCurssusenPage}"
    )
      template(v-slot:top)
        .pr-4.pt-2.pb-2.d-flex.cm-top
          tabs(
            :key="`${$route.query.city}-${$route.query.course_id}`"
            :candidatesCount="candidatesCount"
            @changed="onTabsChange"
          )
        div(:class="{'select-bg-color': activeItems.length && !isMultipleMode, 'multiple-select-bg-color': activeItems.length && isMultipleMode }" ).cm-actions.px-4.pt-2.pb-1.d-flex
          div(v-if="activeItems.length").app-table__selected-items-title.mr-2 {{ activeItems.length}} items selected
          select-all(
            v-if="showSelectAll"
            @change="selectAllClick"
            :activeItemsCount="activeItems.length"
            :itemsToSelectCount="pagination.count"
          ).mr-2
          v-spacer(v-if="activeItems.length")
          accept-test(:activeItems="activeItems" v-if="!isCurssusenPage && !isReservedPage").mr-2
          acceptBulk(:activeItems="activeItems" v-if="!isCurssusenPage && !isReservedPage").mr-2
          markAsProcessedBulk(
            :activeItems="activeItems"
            @clearSelection="clearSelection"
            ).mr-3
          addRequests(
            :disabled="!activeItems.length"
            :activeItems="activeItems"
            :defaultCourse="activeSingleCourse"
            v-if="!disabledAddExam"
          ).mr-2
          removeRequests(
            :disabled="!activeItems.length"
            :activeItems="activeItems"
            :defaultCourse="activeSingleCourse"
            v-if="isReserveQueuePage || isExchangeQueuePage"
            ).mr-2
          removeFromAcceptance(
            :disabled="!activeItems.length"
            :activeItems="activeItems"
            v-if="!isReservedPage"
          ).mr-2
          try-to-reserve(:activeItems="activeItems" :disabled="!activeItems.length" v-if="isReservedPage").mr-2

          handleFailedCandidatesProvider(v-slot="handleFailed")
            span
              v-dialog(:value="handleFailed.showing" @input="handleFailed.toggle" scrollable)
                handleFailedBody(
                  :list="handleFailed.failedCandidates"
                  :error="handleFailed.error"
                  :totalSendCount="handleFailed.totalSendCount"
                  @input="handleFailed.toggle"
                )
              span.d-flex
                mijn-bulk(
                  v-if="!isCurssusenPage && !isReservedPage"
                  :disabled="!activeItems.length"
                  :activeItems="activeItems"
                  @send="handleFailed.check($event, activeItems.length)"
                ).mr-2
                bulk-assign-labels(:disabled="!activeItems.length" :activeItems="activeItems").mr-2
                bulk-assign-labels(btnText="Unassign labels" mode="remove" :disabled="!activeItems.length" :activeItems="activeItems").mr-2
                addRequests(
                  exchange
                  :title="'Exchange exam'"
                  :disabled="!activeItems.length"
                  :activeItems="activeItems"
                  :defaultCourse="activeSingleCourse"
                  @send="handleFailed.check($event, activeItems.length)"
                  v-if="isReservedPage || isExchangeQueuePage"
                ).mr-2
                exchange(
                  :disabled="!activeItems.length" 
                  :activeItems="activeItems" 
                  :title="isReserveQueuePage ? 'Suggest exam': 'Suggest exchange'"
                  @send="handleFailed.check($event, activeItems.length)"
                  :isExchange="isReserveQueuePage ? false : true"
                  v-if="isReservedPage || isExchangeQueuePage || isReserveQueuePage"
                ).mr-2
          
                quickReserve(
                  :activeItems="activeItems" 
                  :disabled="!activeItems.length" 
                  @create="quickReserveHandler(handleFailed.check, $event)"
                  v-if="!disabledAddExam"
                ).mr-2
                quickReserve(
                  :activeItems="activeItems" 
                  :disabled="!activeItems.length" 
                  @create="quickReserveHandler(handleFailed.check, $event)"
                  title="Quick Exchange"
                  isExchange=true
                  v-if="isReservedPage || isExchangeQueuePage"
                )
          sync(
            :activeItems="activeItems"
            :disabled="!activeItems.length"
          ).mr-2
          changeCourseBulk(
            v-if="isReservedPage"
            :activeItems="activeItems" 
            :disabled="!activeItems.length"
            @send="onChangeCourseBulk"
          ).mr-2

          copy(:activeItems="activeItems" :disabled="!activeItems.length" :list="list" multiple)
          candidate-color.mr-2(:activeItems="activeItems" :disabled="!activeItems.length")


      template(v-slot:header="headerRow")
        header-row(:headerRow="headerRow")
          
      template(v-slot:item="{item, select, isSelected, index, expand, isExpanded}")
        course-row(
          :item="item",
          :index="index"
          :key="item.ID"
          :isSelected="isSelected"
          :select="select"
          :expand="expand"
          :isExpanded="isExpanded"
          :activeItems="activeItems"
          :primaryPagination="primaryPagination"
          :labels="labels"
          @click:payments="paymentsOpen"
          @onGoToEdit="goToEdit"
          @selectedWithShiftkey="extendedSelection($event, list)"
          @onWillComeUpdate="$emit('needToUpdate:courses')"
        )

      template( v-slot:expanded-item="{ headers, item }")
        td(:colspan="headers.length").pl-0.pr-0.app-table__expand
          candidate-item(
            :ID="item.ID"
            @close="hideExpandBy"
            ref="expand"
            :key='item.ID'
            @saved="updateTableDataBy(item, $event)"
          ).pb-12

      template(v-slot:footer="footerOptions")
        .cm-body__pagination
          slot(name="footer" :footerOptions="footerOptions")

    payments-provider(ref="payments")
      template(v-slot:default="props")
        span
          payments-cancel-provider(
              :ID="props.ID"
              :payments="props.logs"
              @end="props.create"
              @canceled="props.updateCanceledLog"
            )
              template(v-slot:default="{showing, cancelPayment, send, skip, toggle, showWhenHasCreatedPayment, processing}")
                span
                  v-dialog(:value="props.showing" :max-width="800" scrollable @input="props.toggle")
                    payments(
                      v-if="props.showing"
                      :items="props.list"
                      :itemsLoading="props.listLoading"
                      :formErrors="props.formErrors"
                      :editorData="props.editorData"
                      :processing="props.processing"
                      :log="props.logs"
                      @click:custom="props.setNewEditor"
                      @close="props.toggle"
                      @submit="showWhenHasCreatedPayment"
                      @click:payments="paymentsOpen"
                    )
                      template(v-slot:log-actions="{ paymentLog }")
                        v-btn(small icon color="error" :loading="processing" @click="cancelPayment(paymentLog.ID)")
                          v-icon mdi-delete

                  confirmationDialog(
                    v-model="showing"
                    @okBtnClicked="skip"
                    @failBtnClicked="toggle"
                    title="Candidate has payment"
                    descr="Are you sure you want to create new payment and cancel the old one?"
                    okText="ok"
                    failText="cancel"
                  )
</template>

<script>

import {mapState, mapGetters, mapActions, mapMutations} from "vuex"
import SortModel from '../../candidates/core/models/candidatesSortModel'
import expandMixin from "@/app/admin/mixins/expand.mixin"
import AutocompleteRepo from "@/app/admin/modules/candidates/core/models/candidateAutocompleteRepo"
import Repo from "@/services/api/util/auth-repo-local-storage"
import { CANDIDATE_PAGE } from '../../candidates/core/candidates-const'
import CMCoursesRepository from '../core/cm-courses.repo'
import {CM_HEADERS, CURSSUSSEN_HEADERS} from "../core/cm-const"


export default {
  mixins: [expandMixin],
  props: {
    list: Array,
    loading: Boolean,
    candidatesCount: Object,
    primaryPagination: Object,
    courses: Object,
    pagination: Object,
    groupedList: null
  },

  inject: ['candidatesSvc', 'svc', 'getDefaultPagination'],

  watch: {
    '$route.query': function() {
      this.activeItems = []
    },
    isMultipleMode() {
      if(!this.isMultipleMode) this.activeItems = []
    }
  },

  data: () => ({
    sortModel: null,
    sortBy: [],
    sorting: [],
    activeItems: [],
    autocompleteRepo: new AutocompleteRepo(Repo),
  }),

  created() {
    this.autocompleteRepo.loadDataByFields()
    this.initSortModel()
  },

  mounted() {
    this.loadLabels({cache: true})
  },

  computed: {
    ...mapState('cm',{
      isMultipleMode: state => state.isMultipleMode,
    }),

    isCurssusenPage() {
      return this.$route.name === this.$ROUTER_NAMES.CURSSUSEN
    },

    headers() {
      return this.isCurssusenPage ? CURSSUSSEN_HEADERS : CM_HEADERS
    },
    ...mapGetters({
      labels: 'labels/items',
      activeSingleCourse: 'cm/activeSingleCourse'
    }),
    disabledAddExam() {
      if(!this.$route.query.page_name || this.$route.query.page_name === CANDIDATE_PAGE.RESERVED_ALL || this.isReservePageAtCursussen) return true
      return false
    },
    disabledRemoveExam() {
      return this.$route.query.page_name !== CANDIDATE_PAGE.TOP_CBR_QUEUE
    },
    disabledRemoveFromAcceptance() {
      return this.$route.query.page_name === CANDIDATE_PAGE.RESERVED_ALL
    },
    showChangeCourse() {
      return this.$route.query.page_name !== CANDIDATE_PAGE.MIJN_CBR_QUEUE && this.$route.query.page_name !== CANDIDATE_PAGE.TOP_CBR_QUEUE
    },
    showSelectAll() {
      return this.activeItems.length && this.pagination && this.pagination.count > this.pagination.size
    },

    isReservedPage() {
      return this.$route.query.page_name === CANDIDATE_PAGE.RESERVED_ALL ||
        this.$route.query.page_name === CANDIDATE_PAGE.RESERVED_ALL_WILL_COME ||
        this.$route.query.page_name === CANDIDATE_PAGE.RESERVED_ALL_WILL_NOT_COME
    },

    isReserveQueuePage() {
      return this.$route.query.page_name === CANDIDATE_PAGE.TOB_CBR_RESERVE_QUEUE
    },

    isExchangeQueuePage() {
      return this.$route.query.page_name === CANDIDATE_PAGE.TOB_CBR_EXCHANGE_QUEUE
    },

    isResereQueuePage() {
      return this.$route.query.page_name === CANDIDATE_PAGE.TOP_CBR_QUEUE
    },

    isMijnPage() {
      return this.$route.query.page_name === CANDIDATE_PAGE.MIJN_CBR_QUEUE
    },

    isCursssusenPage() {
      return this.$route.name === this.$ROUTER_NAMES.CURSSUSEN
    },

  },

  methods: {
    ...mapMutations({
      showingSlotsForCurssusenPage: 'cm/showingSlotsForCurssusenPage'
    }),
    ...mapActions({
      loadLabels: 'labels/list',
      courseListDetailed: 'cm/courseListDetailed',
    }),
    initSortModel() {
      this.sortModel = new SortModel(this.$route.query)
    },


    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if(data.ordering.length) ordering = data.ordering
      await this.$router.replace({ query: { ...this.$route.query, ordering: ordering}})
      this.$emit('change:ordering')
    },

    paymentsOpen(data) {
      this.$refs.payments.saveCandidateAndOpen(data)
    },
    

    extendedGroupSelection({item, index}) {
      console.log(item, index)
      let selectedGroup
      for(let group in this.groupedList) {
        let selectedItem = this.groupedList[group].items.find(_item => {
          return _item.ID === item.ID
        })
        if(selectedItem) selectedGroup = group
      }
      if(!selectedGroup) return
      this.extendedSelection({item, index}, this.groupedList[selectedGroup].items)
    },

    extendedSelection({item ,index}, list) {
      let activeItemsIndex = this.activeItems.map(item => list.findIndex(_item => _item.ID === item.ID))
      let itemUpperToSelectedIndex = -1
      activeItemsIndex.forEach(activeIndex => {
        if((index > activeIndex) && (itemUpperToSelectedIndex < activeIndex)) itemUpperToSelectedIndex = activeIndex
      })
      if(itemUpperToSelectedIndex < 0) return
      for(let i = itemUpperToSelectedIndex + 1; i < index; i++) {
        this.activeItems.push(list[i])
      }
    },

    quickReserveHandler(callback, res) {
      callback(res, this.activeItems.length)
      this.onQuickReserve()
    },

    async onQuickReserve() {
      //      this.clearSelection();
      const query = this.prepareQueryForGetCourseList()
      await this.courseListDetailed({ query })
      if(this.isCurssusenPage) this.showingSlotsForCurssusenPage()
    },

    prepareQueryForGetCourseList() {
      let query = {...this.$route.query}
      if(this.isCursssusenPage) query.is_provided = true
      delete query.size
      return query
    },

    onTabsChange() {
      this.clearSelection();
      this.$emit('change:query');
    },

    onChangeCourseBulk() {
      this.clearSelection();
      this.$emit('needToUpdate:courses');
      this.$emit('change:query');
    },

    selectAllClick({clear}) {
      this.$emit('selectAllToggle', clear)
    },

    setActiveItems(items) {
      this.activeItems = items;
    },

    clearSelection() {
      this.activeItems = [];
    },

    loadList() {
      this.$emit('change:query');
    }
  },

  provide: function() {
    return {
      autocompleteRepo: this.autocompleteRepo,
      svc: () => this.candidatesSvc
    }
  },

  components: {
    courseRow: () => import('./CMCourseRow.vue'),
    bulkAssignLabels: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesBulkAssignLabels.vue'),
    PaymentsProvider: () => import('@/app/admin/modules/candidates/components/payments/CanidatesPaymentsProvider'),
    Payments: () => import('@/app/admin/modules/candidates/components/payments/CandidatesPayments.vue'),
    paymentsCancelProvider: () => import('@/app/admin/modules/candidates/components/payments/CandidatesPaymentCancelProvider.vue'),
    copy: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesCopy.vue'),
    candidateItem: () => import('@/app/admin/modules/candidates/components/item/CandidateItem.vue'),
    addRequests: () => import('@/app/admin/modules/candidates/components/CandidatesAddExamRequest.vue'),
    tabs: () => import('./CMTabs.vue'),
    acceptBulk: () => import('@/app/admin/modules/candidates/components/CandidateAcceptActivatorBulk.vue'),
    markAsProcessedBulk: () => import('./CMMarkAsProceedBulk.vue'),
    acceptTest: () => import('@/app/admin/modules/candidates/components/CandidatesAcceptTest.vue'),
    mijnBulk: () => import('@/app/admin/modules/candidates/components/CandidatesMIJNBulk.vue'),
    handleFailedCandidatesProvider: () => import('@/app/admin/modules/candidates/components/CandidatesHandleFailedProvider'),
    handleFailedBody:() => import('@/app/admin/modules/candidates/components/CandidatesHandleFailedBody.vue'),
    selectAll: () => import('@/app/admin/modules/candidates/components/CandidateSelectAll.vue'),
    quickReserve: () => import('../components/CMQuickReserve.vue'),
    removeRequests: () => import('@/app/admin/modules/candidates/components/CandidatesRemoveExamRequest.vue'),
    tryToReserve: () => import('@/app/admin/modules/candidates/components/CandidatesTryToReserve.vue'),
    removeFromAcceptance: () => import('@/app/admin/modules/candidates/components/CandidatesRemoveFromAcceptance.vue'),
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue'),
    exchange: () => import('@/app/admin/modules/candidates/components/CandidatesExchange.vue'),
    changeCourseBulk: () => import('@/app/admin/modules/candidates/components/CandidatesChangeCourseBulk.vue'),
    courseConfigurationBulk: () => import('./curssusen/CMAssignCourseConfiguration.vue'),
    sync: () => import('@/app/admin/modules/candidates/components/CandidatesSync.vue'),
    candidateColor: () => import('@/app/admin/modules/candidates/components/CandidateColor.vue'),
    headerRow: () => import('./CMHeaders.vue'),
    filters: () => import('./cm_filters/CMFilters.vue'),
    groupedTable: () => import('@/components/global/GroupedTable.vue')
  }
}
</script>

<style lang="scss" scoped>

.cm-body::v-deep {
  &__table {
    @extend %visible-scrollbar;
    box-shadow: unset;
    position: relative;
    overflow: auto;
    height: calc(100% - 64px);
  }
}
.cm-body {
  width: calc(100% - 268px);
  height: calc(100vh - 135px);
  min-height: calc(100vh - 135px);

  overflow: auto;
  &.without-course-config {
    width: calc(100% - 170px);
  }
  &.curssusen-body {
    width: 100%;
  }
  &__table {
    @extend %visible-scrollbar;
    box-shadow: unset;
    position: relative;
    overflow: auto;
    height: calc(100% - 64px);
  }

  &__wrapper {
    width: 100%;
    height: 100%;

    &::v-deep {
      .v-data-table__wrapper {
        overflow: visible;

        > table {
          width: auto;
        }
      }
    }
  }

  &__pagination {
    position: -webkit-sticky;
    position: sticky;
    width: 100%;
    left: 0;
  }

  @media(max-width: 767px) {
    width: 100%;
  }
}

.app-table__selected-items-title {
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.multiple-select-bg-color .app-table__selected-items-title{
  color: white;
}

.app-table::v-deep table {
  table-layout: fixed;
  min-width: 1490px;
  & th:first-child {
    width: 30px !important;
  }
  & th:last-child, td:last-child {
    padding-right: 8px;
  }
  .cell-btns {
    width: 40px;
  }
  .cell {
    &-name {
      width: 127px;
    }
    &-index {
      width: 36px;
    }
    &-cbr {
      width: 70px;
    }
    &-appid {
      width: 70px;
    }
    &-reserved {
      width: 122px;
    }
    &-bday {
      width: 95px;
    }
    &-hold {
      width: 68px;
    }
    &-status {
      width: 61px;
    }
    &-delete {
      width: 25px;
    }
    &-error {
      width: 100px;
    }
    &-email {
      width: 28px;
    }
    &-dates {
      width: 120px;
    }
    &-placed-paid {
      width: 90px;
    }
    &-reservation {
      width: 150px;
    }
    &-product {
      width: 80px;
    }
     &-email {
      width: 28px;
    }
    &-number {
      width: 100px;
    }
    &-app-note {
      width: 80px;
    }
    &-note {
      text-align: center;
      min-width: 50px;
    }
    &-payment {
      width: 70px;
    }
    &-configuration {
      width: 150px;
    }
  }
}

.cm-top {
  align-items: center;
  border-bottom: 1px solid $border-color;
  padding-left: 8px;
  position: sticky;
  left: 0;
}
.cm-actions {
  width: 100%;
  border-bottom: 1px solid $border-color;
  flex-wrap: wrap;
  position: sticky;
  left: 0;
  flex-wrap: wrap;
  > * {
    margin-bottom: 6px;
  }
}

.multiple-select-bg-color ::v-deep {
  .v-btn.primary--text{
    color: white !important;
  }
  .v-icon{
    color: white;
  }
  .select-all{
    color: white;
  }
}

.table-curssusen::v-deep table {
  min-width: 1250px;
}
</style>
